'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _ListElement = require('./ListElement');

var _ListElement2 = _interopRequireDefault(_ListElement);

var _ListDropPreview = require('./ListDropPreview');

var _ListDropPreview2 = _interopRequireDefault(_ListDropPreview);

var _EmptyListPlaceholder = require('./EmptyListPlaceholder');

var _EmptyListPlaceholder2 = _interopRequireDefault(_EmptyListPlaceholder);

require('./List.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Components


var ListPresentational = function ListPresentational(props) {
    var children = props.children,
        isHovered = props.isHovered,
        isPresentational = props.isPresentational,
        registerListElement = props.registerListElement,
        deregisterListElement = props.deregisterListElement,
        hoveredIndex = props.hoveredIndex,
        gridSize = props.gridSize,
        inListClass = props.inListClass,
        currentBoardId = props.currentBoardId,
        isEditable = props.isEditable,
        documentMode = props.documentMode,
        elementFilter = props.elementFilter,
        deselectAll = props.deselectAll,
        createShortcutElement = props.createShortcutElement,
        createShortcutCard = props.createShortcutCard,
        createShortcutImage = props.createShortcutImage,
        createShortcutLink = props.createShortcutLink,
        readyToMeasure = props.readyToMeasure;


    var listIndex = 0;
    var showDropPreview = isHovered && hoveredIndex !== null && children.size > 0;
    var displayElements = showDropPreview ? Immutable.List([].concat(_toConsumableArray(children.slice(0, hoveredIndex)), [{ preview: true }], _toConsumableArray(children.slice(hoveredIndex)))) : children;

    var renderElements = displayElements.map(function (element) {
        if (element.preview) return _react2.default.createElement(_ListDropPreview2.default, { key: 'dropPreview' });

        var i = listIndex;
        listIndex++;

        return _react2.default.createElement(_ListElement2.default, {
            element: element,
            gridSize: gridSize,
            inList: inListClass || 'in-list',
            key: element.get('id'),
            currentBoardId: currentBoardId,
            isPresentational: isPresentational,
            registerListElement: registerListElement,
            deregisterListElement: deregisterListElement,
            deselectAll: deselectAll,
            createShortcutElement: createShortcutElement,
            createShortcutCard: createShortcutCard,
            createShortcutImage: createShortcutImage,
            createShortcutLink: createShortcutLink,
            listIndex: i,
            documentMode: documentMode,
            isEditable: isEditable,
            elementFilter: elementFilter,
            readyToMeasure: readyToMeasure });
    });

    return _react2.default.createElement(
        'div',
        { className: 'List' },
        children.size === 0 ? _react2.default.createElement(_EmptyListPlaceholder2.default, props) : renderElements
    );
};

ListPresentational.propTypes = {
    listId: _propTypes2.default.string.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.object.isRequired,
    connectDropTarget: _propTypes2.default.func,
    isHovered: _propTypes2.default.bool,
    hoveredIndex: _propTypes2.default.number,
    isPresentational: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    registerListElement: _propTypes2.default.func,
    deregisterListElement: _propTypes2.default.func,
    gridSize: _propTypes2.default.number,
    inListClass: _propTypes2.default.string,
    documentMode: _propTypes2.default.bool,
    elementFilter: _propTypes2.default.object,
    deselectAll: _propTypes2.default.func,
    createShortcutElement: _propTypes2.default.func,
    createShortcutCard: _propTypes2.default.func,
    createShortcutImage: _propTypes2.default.func,
    createShortcutLink: _propTypes2.default.func,
    readyToMeasure: _propTypes2.default.bool
};

exports.default = ListPresentational;


//////////////////
// WEBPACK FOOTER
// ./src/client/list/ListPresentational.js
// module id = 747
// module chunks = 0